<template></template>
<script>
export default {
  mounted() {
    console.log('404 mounted.')
  }
}
</script>
